import { z } from 'zod';
/**
 * Native (Expo) push device registration — apps/api `modules/mobile-push`
 * (device-tokens.controller.ts), mobile-app-expo phase 3.
 *
 *   POST   /api/mobile/devices         DeviceRegisterRequest -> DeviceTokenView
 *   DELETE /api/mobile/devices/:token  (on logout)           -> { success: true }
 *   GET    /api/mobile/devices/me                              -> DeviceTokenView[]
 *
 * All three accept the mobile Bearer token (AnyAuthGuard). The token is an
 * Expo push token (`ExponentPushToken[...]` / `ExpoPushToken[...]`); the
 * server upserts by token, so re-registering after an app update or a user
 * switch on the same phone moves the token to the caller.
 */
/** `ExponentPushToken[xxxx]` or `ExpoPushToken[xxxx]` — the Expo SDK's own shape check. */
export const EXPO_PUSH_TOKEN_PATTERN = /^Expo(nent)?PushToken\[[^\]]+\]$/;
export const DevicePlatformSchema = z.enum(['ios', 'android']);
export const DeviceRegisterRequestSchema = z.object({
    token: z.string().trim().max(256).regex(EXPO_PUSH_TOKEN_PATTERN, 'Not an Expo push token'),
    platform: DevicePlatformSchema,
    appVersion: z.string().trim().min(1).max(32),
    /** BCP-47-ish app locale ("uk", "en-US"). Server falls back to the user's locale. */
    locale: z.string().trim().min(2).max(16).optional(),
});
/** What the API answers about one registered device. Never another user's. */
export const DeviceTokenViewSchema = z.object({
    token: z.string(),
    platform: DevicePlatformSchema,
    appVersion: z.string(),
    locale: z.string().nullable(),
    createdAt: z.string(),
    lastSeenAt: z.string(),
    disabledAt: z.string().nullable(),
    disabledReason: z.string().nullable(),
});
//# sourceMappingURL=mobile-push.js.map